<ng-container *ngFor="let creditor of formData.creditors; let i = index">

  <h6>Creditor {{ i+1 }}</h6>
  <div class="row">

    <div class="col-md-4">
      <div class="form-group row">
        <label for="creditor{{ i+1 }}Name" class="col-sm-4 col-form-label">Name<sup class="text-danger">*</sup></label>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="creditor{{ i+1 }}Name" placeholder="Creditor {{ i+1 }} Name" [(ngModel)]="creditor.name" required>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group row">
        <label for="creditor{{ i+1 }}Reference" class="col-sm-4 col-form-label">Reference</label>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="creditor{{ i+1 }}Reference" placeholder="Creditor {{ i+1 }} Reference" [(ngModel)]="creditor.reference">
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group row">
        <label for="creditor{{ i+1 }}Balance" class="col-sm-4 col-form-label">Balance</label>
        <div class="col-sm-8">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroupPrepend">&pound;</span>
            </div>
            <input type="number" class="form-control form-control-sm" id="creditor{{ i+1 }}Balance" placeholder="Creditor {{ i+1 }} Balance" [(ngModel)]="creditor.balance" [required]="checkValue(creditor.balance)">
          </div>
        </div>
      </div>
    </div>

  </div>

</ng-container>

<button type="button" class="btn btn-sm btn-default" (click)="addCreditor()">Add Creditor</button>



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/creditor-details/app-creditor-details.component.html